<script setup lang="ts">
import { ref, computed } from 'vue'
import draggable from 'vuedraggable'
import { ChevronDown, ChevronRight, SquarePen, CirclePlus } from 'lucide-vue-next'
import { useModalStore } from '@/store/modal'
const modal = useModalStore()
import { Category } from '@/types'
import { useAuthAccess } from '@/composables/useAuthAccess'
const { hasPermission, hasAnyPermission, hasRole, hasAnyRole } = useAuthAccess()
const props = defineProps<{ modelValue: Category[], activeNodeId: string }>()
const emit = defineEmits<{ 
  'update:modelValue': Category[], 
  'update:activeNodeId': string,
  'refresh': void
}>()

const list = computed({
  get: () => props.modelValue,  
  set: (v: Category[]) => emit('update:modelValue', v)
})

const collapsed = ref<Record<number, boolean>>({})
function toggle(node: Category) {
  collapsed.value[node.id] = !collapsed.value[node.id]
}
function isCollapsed(node: Category) {
  return !!collapsed.value[node.id]
}
function edit(node: Category) {
  modal.openModal('CreateUpdateCategoryModal', {
    category: node,
  }).then((result) => {
    console.log(result)
    emit('refresh')
  }).catch((err) => {
    console.log(err)
  })
}
function handleAddCategory(node: Category) {
  console.log(node)
    modal.openModal('CreateUpdateCategoryModal', {
      country_id: node.country_id,
      parent_id: node.id,
    }).then((result) => {
      console.log(result)
      emit('refresh')
    }).catch((err) => {
      console.log(err)
    })
}
function handleClick(node: Category) {
    emit('update:activeNodeId', node.id)
}
const getBgColor = (level: number) => {
    switch(level) {
        case 0: return 'bg-transparent';
        case 1: return 'bg-[#F5F5F5]';
        case 2: return 'bg-[#E0E0E0]';
        case 3: return 'bg-[#BDBDBD]';
        case 4: return 'bg-[#9E9E9E ]';
        default: return 'bg-[#F1C40F]';
    }
}
</script>

<template>
  <draggable v-model="list" item-key="id" group="nested" class="bg-white rounded-[4px] min-w-[250px]" :disabled="true">
    <template #item="{ element: node }">
      <div class="ml-0" :class="getBgColor(node.level)">
        <div class="flex items-center justify-between p-1 space-x-2" >
            <div v-for="i in node.level" :key="i" class="w-[20px] m-[0px]"></div>
            <button @click="toggle(node)" v-if="node.children.length" class="mr-1">
                <ChevronDown v-if="!isCollapsed(node)" />
                <ChevronRight v-else />
            </button>
            <span class="w-full m-[0px] cursor-pointer" :class="{ 'underline': activeNodeId === node.id }" @click="handleClick(node)">{{ node.name }}</span>
            <template v-if="hasPermission('dictionary:categories:manage')">
              <button @click="handleAddCategory(node)"><CirclePlus :size="18"/></button>
              <button @click="edit(node)"><SquarePen :size="18"/></button>
            </template>
        </div>
        <CategoryTree
            v-if="!isCollapsed(node)"
            v-model="node.children"
            :active-node-id="activeNodeId"
            @update:active-node-id="emit('update:activeNodeId', $event)"
            @refresh="emit('refresh')"
        />
      </div>
    </template>
  </draggable>
</template>

<style scoped>
ul, li { list-style: none; margin: 0; padding: 0; }
li { margin-left: 16px; }
</style>